import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: var(--if-ink-3);
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const CodeBlock = styled.pre`
  margin: 0;
  padding: 8px 12px;
  border-radius: 4px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-word;
  background: ${({ variant }) =>
    variant === 'before'
      ? 'var(--if-diff-remove-bg)'
      : 'var(--if-diff-add-bg)'};
  border: 1px solid
    ${({ variant }) =>
      variant === 'before'
        ? 'var(--if-diff-remove-border)'
        : 'var(--if-diff-add-border)'};
  color: ${({ variant }) =>
    variant === 'before'
      ? 'var(--if-diff-remove-ink)'
      : 'var(--if-diff-add-ink)'};
`;

function formatJson(value) {
  if (value === null || value === undefined) return 'null';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (_e) {
      return value;
    }
  }
  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
}

export default function JsonDiff({ from = null, to = null }) {
  return (
    <Wrapper>
      <Label>before</Label>
      <CodeBlock variant="before">{formatJson(from)}</CodeBlock>
      <Label>after</Label>
      <CodeBlock variant="after">{formatJson(to)}</CodeBlock>
    </Wrapper>
  );
}
JsonDiff.propTypes = {
  // from/to can legitimately be null or undefined (e.g. a field was
  // added or removed); formatJson renders "null" for those cases.
  from: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
  ]),
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
  ]),
};
